import { Text } from '@react-pdf/renderer';

import { getCommentaryTableHelperText } from '../../../redux/features/selectors/utils/getCommentaryTableHelperText.ts';
import { COMMENTARY_TEXT } from '../../commentary/consts.ts';
import { ExportCommentaryTable } from '../../commentary/export/ExportCommentaryTable.tsx';
import { convertComparableSalesDataToStringArray } from '../../commentary/export/convertComparableSalesDataToStringArray.ts';
import { CommentarySection } from '../components/CommentarySection.tsx';
import { Tkv2PDFPage } from '../components/Tkv2PDFPage.tsx';
import { fontStyles } from '../styles.ts';
import { ListToSalePageProps } from '../types.ts';

export const ListToSalePage = ({
  subjectAddress,
  adjustmentSettings,
  adjustmentsTableData,
}: ListToSalePageProps) => {
  const listToSaleTableData = adjustmentsTableData.listToSale;
  if (!listToSaleTableData) return null;

  const { commentary, method, ratio, tableData } = listToSaleTableData;

  const { title, subtitle, headerText } = COMMENTARY_TEXT['list-to-sale'];

  const helperText = getCommentaryTableHelperText(adjustmentSettings, 'dateOfSale');

  if (method === 'none') return null;

  return (
    <Tkv2PDFPage title={title} address={subjectAddress}>
      <Text style={fontStyles.body}>{subtitle}</Text>
      <Text style={fontStyles.h4}>{headerText}</Text>
      <ExportCommentaryTable data={convertComparableSalesDataToStringArray(tableData)} />
      <Text style={fontStyles.body}>
        {`List to sale price adjustment: ${ratio ? `${ratio}%` : '-'}`}
      </Text>
      <Text style={fontStyles.small}>{helperText}</Text>
      <CommentarySection title="List to Sale Commentary" commentary={commentary} />
    </Tkv2PDFPage>
  );
};
